module.exports = __webpack_public_path__ + "static/media/color-chooser_codepen.6c6ea97b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/codepen-imgs/color-chooser_codepen.jpg
// module id = 77
// module chunks = 0